module.exports = "/lucky-balls/img/jackpot/009.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/009.png
// module id = 1109
// module chunks = 0